<template>
    <div id="footer-bar" class="footer-bar-2">
        <router-link :to="{name: 'accueil'}">
            <i class="fi fi-br-home"></i>
            <span>Accueil</span>
        </router-link>
        <router-link :to="{name: 'produits', params: {slug: 'menus'}}">
            <i class="fi fi-br-hamburger"></i>
            <span>Nos menus</span>
        </router-link>
        <router-link :to="{name: 'panier'}">
            <i class="fi fi-br-shopping-cart"></i>
            <span>Panier</span>
            <em class="badge" :class="reponseVisuelle ? 'bg-success' : 'bg-warning'">{{ getCount }}</em>
        </router-link>
        <router-link :to="{name: 'compte'}">
            <i class="fi fi-br-user"></i>
            <span>Mon compte</span>
        </router-link>
    </div>
</template>

<script>

export default {
    data() {
        return {
            reponseVisuelle: false
        }
    },
    computed: {
        getCount() {
            return this.$store.getters["panier/getCount"]
        }
    },
    watch: {
        getCount: function (newVal) {
            this.reponseVisuelle = true;
            setTimeout(() => {
                this.reponseVisuelle = false;
            }, 1500)
        }
    },
}
</script>
